import React, { useMemo, useState } from "react";
import countryList from "react-select-country-list";
import CardBody from "../../../components/Card/CardBody";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import Card from "../../../components/Card/Card";
import { Grid } from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import Subscription from "../../../licensing/Models/Subscription";
import { Link } from "react-router";
import { Add } from "@mui/icons-material";
import Button from "../../../components/CustomButtons/Button";
import Tooltip from "@mui/material/Tooltip";
import * as actions from "../../../store/actions";
import { connect } from "react-redux";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import FormSelectTC from "../../../components/Forms/FormSelectTC";

function VenueGeneral(props) {
  const { classes } = props;
  const [valueCountry, setValueCountry] = useState("NL");
  const countryOptions = useMemo(() => convertArrayToSelectOptions(countryList().getData()), []);
  let activeSubscription = false;

  const changeHandlerCountry = (value) => {
    setValueCountry(value);
  };

  return (
    <>
      <Card style={{ maxWidth: 600 }}>
        <CardBody style={{ padding: 16 }}>
          <Grid container spacing={1}>
            <FormTextTC
              name={"name"}
              rules={{ required: getTranslation("This field is required!") }}
              tKey={"Venue name"}
            />
            <FormTextTC
              name={"address"}
              rules={{ required: getTranslation("This field is required!") }}
              tKey={"Address"}
            />
            <FormTextTC name={"city"} rules={{ required: getTranslation("This field is required!") }} tKey={"City"} />

            <FormTextTC
              name={"postal_code"}
              rules={{ required: getTranslation("This field is required!") }}
              tKey={"Postal code"}
            />
            <FormSelectTC
              name={"country"}
              onChange={changeHandlerCountry}
              options={countryOptions}
              tDefault={"Country"}
              tKey={"Country"}
              value={valueCountry}
            />
            <FormTextTC
              name={"phone_number"}
              rules={{ required: getTranslation("This field is required!") }}
              tKey={"Phone number"}
            />
            <FormTextTC
              name={"email_address"}
              rules={{ required: getTranslation("This field is required!") }}
              tKey={"E-mail address"}
              textFieldType={"email"}
            />
            <FormTextTC name={"website"} tKey={"Website"} />
            <FormTextTC
              name={"email_address"}
              rules={{ required: getTranslation("This field is required!") }}
              tKey={"E-mail address"}
              textFieldType={"email"}
            />
            <FormTextTC name={"vat_number"} tKey={"VAT number"} />
            <FormTextTC name={"coc_number"} tKey={"COC number"} />
          </Grid>
        </CardBody>
      </Card>
      <Card style={{ maxWidth: 600 }}>
        <CardBody style={{ padding: 16 }}>
          <GridContainer>
            <GridItem sm={6} xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Licenses"} tKey={"licenses"} />
              </h3>
              {props.model?.subs_subscriptions
                ?.sort((a, b) => {
                  return a.start_date_unix - b.start_date_unix;
                })
                .map((subsSubscription) => {
                  const subscription = Subscription.CreateModel(subsSubscription);
                  if (subscription.isActive()) {
                    activeSubscription = true;
                  }
                  return (
                    <GridContainer>
                      <GridItem sm={4} xs={12}>
                        <Link to={Subscription.editPath(subscription.id)}>License</Link>
                      </GridItem>
                      <GridItem sm={4} xs={12}>
                        {subscription.start_date?.toLocaleDateString() ?? <TranslationWrapper tKey={"No start date"} />}{" "}
                        - {subscription.end_date?.toLocaleDateString() ?? <TranslationWrapper tKey={"No end date"} />}
                      </GridItem>
                      <GridItem sm={4} xs={12}>
                        {subscription.isActive() ? "Active" : "Not active"}
                      </GridItem>
                    </GridContainer>
                  );
                })}

              {!activeSubscription ? (
                <GridContainer>
                  <GridItem sm={4} xs={12}>
                    <Link to={"/manager/subssubscriptions/create"}>
                      <Tooltip placement={"bottom"} title={"Open"}>
                        <Button
                          className={classes.marginRight}
                          color={"success"}
                          onClick={() => {
                            props.setFilter("venue_id", {
                              field: "venue_id",
                              operator: "=",
                              value: Number(props.model.id),
                              label: props.model.name,
                            });
                            props.setFilter("vestiging.venue_id", {
                              field: "vestiging.venue_id",
                              operator: "=",
                              value: Number(props.model.id),
                              label: props.model.name,
                            });
                          }}
                        >
                          <Add className={classes.icons} /> Create license
                        </Button>
                      </Tooltip>
                    </Link>
                  </GridItem>
                </GridContainer>
              ) : null}
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
  };
};

export default connect(null, mapDispatchToProps)(VenueGeneral);
